export const CUSTOMER_ORG_DETAILS_ACTION_PREFIX = '[Customer Org Details State] ';

export class FetchCustomerOrgDetails {
  static readonly type = `${CUSTOMER_ORG_DETAILS_ACTION_PREFIX} Fetch Customer Organization Details`;
  constructor(public orgId: string) {}
}

